/** --------------------------------------------------
*
*   pages - overview page
*   OVERVIEW PAGE SCROLL POSITION
*
*  -------------------------------------------------- */

(function ($, Drupal, duo) {

  $(function() {

    // check if there is a scroll position in session storage,
    // if there is, and we're on a product overview page or a brand page,
    // restore the scroll:
    const overviewPageScroll = sessionStorage.getItem('overview-page-scroll');
    if(overviewPageScroll !== null) {
      if(isProductOverviewPage() || isBrandPage()) {

        // restore the scroll to the saved position:
        // $("html, body").scrollTop(overviewPageScroll);

        // restore the scroll to a fixed element:
        const $pageContentElement = $(document).find('#overview-page-content');
        if($pageContentElement.length > 0) {
          const pageContentOffset = $pageContentElement.offset().top;
          $("html, body").scrollTop(pageContentOffset);
        }
      }
      // remove the data from sessionStorage:
      sessionStorage.removeItem('overview-page-scroll');
    }
  });

  Drupal.behaviors.overview_page_scroll_position = {

    attach: function (context, settings) {
      const self = this;

      // only do the following once:
      $(document, context).once('overview_page_scroll_position').each(function() {
        self.init(context, settings);
      });
    },

    init: function(context, settings) {
      const self = this;

      // setup filter links:
      self.setupFilterLinks();
    },

    setupFilterLinks() {

      // save the page scroll position when clicking on anchor links
      // (to be able to restore the scroll position on a subsequent page load)

      $(document).on('click', '.facet-item a[data-drupal-facet-item-value]', function(e){
        e.preventDefault();
        let $facetLink = $(this);
        let linkUrl = $facetLink.attr('href');

        // save the page scroll in session storage:
        const scroll = $(window).scrollTop();
        sessionStorage.setItem('overview-page-scroll', scroll);

        // follow link:
        location.href = linkUrl;
     });

     // save the page scroll position when checking or unchecking
     // a facet checkbox

     $('.facets-checkbox').change(function() {
        const scroll = $(window).scrollTop();
        sessionStorage.setItem('overview-page-scroll', scroll);
      });
    },
  };

  function isProductOverviewPage() {
    let isOverviewPage = false;

    if($('body').hasClass('node--type-product-category')) {
      isOverviewPage = true;
    }

    return isOverviewPage;
  }

  function isBrandPage() {
    let isBrandPage = false;

    if($('body').hasClass('node--type-brand')) {
      isBrandPage = true;
    }

    return isBrandPage;
  }
})(jQuery, Drupal, window.duo = window.duo || {});
